"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("@phishtool/ui");
const styled_1 = require("./styled");
const _service_1 = require("~service");
const complianceDocuments = [
    {
        label: 'Data Processing Addendum (DPA) Cover Note.pdf',
        id: 'data-processing-addendum-cover-note',
    },
    {
        label: 'Data Processing Agreement.pdf',
        id: 'data-processing-agreement',
    },
    {
        label: 'Privacy Policy.pdf',
        id: 'privacy-policy',
    },
    {
        label: 'Proof of Value Agreement.pdf',
        id: 'proof-of-value-agreement',
    },
    {
        label: 'Security and Compliance Overview.pdf',
        id: 'security-and-compliance-overview',
    },
    {
        label: 'Service Agreement.pdf',
        id: 'service-agreement',
    },
    {
        label: 'Terms of Service.pdf',
        id: 'terms-of-service',
    },
];
const ComplianceDocuments = () => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const closeModal = () => setIsOpen(false);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(styled_1.StyledQuoteButton, { href: "#", onClick: (e) => {
                    e.preventDefault();
                    setIsOpen(true);
                }, children: [(0, jsx_runtime_1.jsx)("span", { children: "Compliance documents" }), (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: "document", size: { width: 52, height: 36 }, alignment: "vertical" })] }), (0, jsx_runtime_1.jsx)(ui_1.Modal, { isOpen: isOpen, closeModal: closeModal, heading: "Compliance documents", headingSize: "large", size: "small", children: (0, jsx_runtime_1.jsx)(styled_1.StyledDownloadList, { children: complianceDocuments.map((complianceDocument) => ((0, jsx_runtime_1.jsx)(styled_1.StyledDownloadListItem, { children: (0, jsx_runtime_1.jsx)(ui_1.Link, { color: "burntOrange", to: _service_1.contentService.getComplianceDocumentUrl({ contentId: complianceDocument.id }), download: complianceDocument.label, downloadIcon: true, children: complianceDocument.label }) }, complianceDocument.id))) }) })] }));
};
exports.default = ComplianceDocuments;
